const DepUsersSection = () => import("@/components/users/DepUsersSection.vue");
const DepPaymentUsersSection = () =>
  import(
    "@/features/dep/users/payments/presentation/views/UsersPaymentListView.vue"
  );
const UsersTabsContainer = () =>
  import("@/features/dep/users/home/presentation/views/UsersTabsContainer.vue");

export const userRoutes = [
  {
    path: "/users",
    component: UsersTabsContainer,
    children: [
      {
        name: "users",
        path: "/",
        component: DepUsersSection,
      },
      {
        name: "users-payments",
        path: "payments",
        component: DepPaymentUsersSection,
      },
    ],
  },
];
